// extracted by mini-css-extract-plugin
export default {"info":"PersonInfo_info__M7B7r","list":"PersonInfo_list__e+PR6","item":"PersonInfo_item__7Njjq","title":"PersonInfo_title__Jixr1"};